import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import secureApi from '../helpers/secureApi';
import postHeaders from '../helpers/postHeaders';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Button from '../components/AddFolder/Button';
import Message from '../components/common/Message';

export default function AddFolder() {

  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');
  const {id} = useParams();

  useEffect(()=>{
    setMsg('');
    if(id){
      axios.get(secureApi('get-folder-by-id?id='+id))
      .then(response=>{
        if(response?.data?.folder?.name){
          setName(response?.data?.folder?.name);
        }
      })
      .catch(e=> console.log('error get-folder-by-id', e))
    }
  }, [id]);

  const saveFolder = async (e: React.FormEvent<HTMLFormElement>) =>{
    e.preventDefault();
    setMsg('');
    if(name){
      let api = secureApi('add-folder');
      if(id){
        api = secureApi('update-folder');
      }
      if(api){
        const response = await axios.post(api, {name, id});
        if(response?.data?.folder?.name){
          setMsg('Record has been saved');
        }
        console.log("response", response);
      }
      else{
        console.log("saveFolder, api not found");
      }
    }
    else{
      console.log("saveFolder, name is required");
    }
  }

  return (
    <Layout>
      <div className='formWrap'>
        <div><h1>{id ? 'Edit' : 'Add'} Folder</h1></div>
        <form onSubmit={saveFolder}>
          <input value={name} type="text" placeholder='Name...' onChange={(e:React.ChangeEvent<HTMLInputElement>)=>setName(e.target.value)} />
          <Button id={id} name={name} />
        </form>
        <Message msg={msg} />
      </div>
    </Layout>
  )
}
